module.exports = __webpack_public_path__ + "static/media/bgShare3@2x.598e7d7c.png";


//////////////////
// WEBPACK FOOTER
// ./src/modules/wechatShare/components/images/bgShare3@2x.png
// module id = 888
// module chunks = 0